module.exports = __webpack_public_path__ + "media/src/images/icons/download/primary-53d0e839fcf8fad27a80dc33a949108a.svg";